import { gql } from "@apollo/client";

/* ── Fragments ────────────────────────────────────────────────────── */

export const PRICING_PLAN_FIELDS = gql`
  fragment PricingPlanFields on PricingPlan {
    id
    name
    authAmount
    hourlyRate
    createdAt
  }
`;

export const BOOKING_TYPE_FIELDS = gql`
  fragment BookingTypeFields on BookingType {
    id
    name
    description
    slug
    isActive
    sortOrder
    state
    customerCountType
    minCustomers
    maxCustomers
    agreementType
    agreementTypeId
    createdAt
    pricingPlans {
      id
      bookingTypeId
      pricingPlanId
      minCustomerCount
      maxCustomerCount
      createdAt
    }
  }
`;

/* ── Queries ──────────────────────────────────────────────────────── */

export const ALL_BOOKING_TYPES = gql`
  ${BOOKING_TYPE_FIELDS}
  query AllBookingTypesForCatalog {
    allBookingTypes(
      page: 0
      perPage: 100
      sortField: "sortOrder"
      sortOrder: "ASC"
    ) {
      ...BookingTypeFields
    }
  }
`;

export const ALL_PRICING_PLANS = gql`
  ${PRICING_PLAN_FIELDS}
  query AllPricingPlansForCatalog {
    allPricingPlans(
      page: 0
      perPage: 100
      sortField: "name"
      sortOrder: "ASC"
    ) {
      ...PricingPlanFields
    }
  }
`;

export const GET_BOOKING_TYPE = gql`
  ${BOOKING_TYPE_FIELDS}
  query GetBookingTypeForEdit($id: String!) {
    BookingType(id: $id) {
      ...BookingTypeFields
    }
  }
`;

export const GET_PRICING_PLAN = gql`
  ${PRICING_PLAN_FIELDS}
  query GetPricingPlanForEdit($id: String!) {
    PricingPlan(id: $id) {
      ...PricingPlanFields
    }
  }
`;

/* ── Mutations ────────────────────────────────────────────────────── */

export const CREATE_BOOKING_TYPE = gql`
  ${BOOKING_TYPE_FIELDS}
  mutation CreateBookingTypeInPortal(
    $name: String!
    $description: String
    $slug: String
    $isActive: Boolean
    $sortOrder: Int
    $state: String
    $customerCountType: String
    $minCustomers: Int
    $maxCustomers: Int
    $agreementType: String
    $agreementTypeId: String
    $pricingPlans: [BookingTypePricingPlanInput]
  ) {
    createBookingType(
      name: $name
      description: $description
      slug: $slug
      isActive: $isActive
      sortOrder: $sortOrder
      state: $state
      customerCountType: $customerCountType
      minCustomers: $minCustomers
      maxCustomers: $maxCustomers
      agreementType: $agreementType
      agreementTypeId: $agreementTypeId
      pricingPlans: $pricingPlans
    ) {
      ...BookingTypeFields
    }
  }
`;

export const UPDATE_BOOKING_TYPE = gql`
  ${BOOKING_TYPE_FIELDS}
  mutation UpdateBookingTypeInPortal(
    $id: String!
    $name: String
    $description: String
    $slug: String
    $isActive: Boolean
    $sortOrder: Int
    $state: String
    $customerCountType: String
    $minCustomers: Int
    $maxCustomers: Int
    $agreementType: String
    $agreementTypeId: String
    $pricingPlans: [BookingTypePricingPlanInput]
  ) {
    updateBookingType(
      id: $id
      name: $name
      description: $description
      slug: $slug
      isActive: $isActive
      sortOrder: $sortOrder
      state: $state
      customerCountType: $customerCountType
      minCustomers: $minCustomers
      maxCustomers: $maxCustomers
      agreementType: $agreementType
      agreementTypeId: $agreementTypeId
      pricingPlans: $pricingPlans
    ) {
      ...BookingTypeFields
    }
  }
`;

export const DELETE_BOOKING_TYPE = gql`
  mutation DeleteBookingTypeInPortal($id: String!) {
    deleteBookingType(id: $id) {
      id
    }
  }
`;

export const CREATE_PRICING_PLAN = gql`
  ${PRICING_PLAN_FIELDS}
  mutation CreatePricingPlanInPortal(
    $name: String!
    $authAmount: Float!
    $hourlyRate: Float!
  ) {
    createPricingPlan(
      name: $name
      authAmount: $authAmount
      hourlyRate: $hourlyRate
    ) {
      ...PricingPlanFields
    }
  }
`;

export const UPDATE_PRICING_PLAN = gql`
  ${PRICING_PLAN_FIELDS}
  mutation UpdatePricingPlanInPortal(
    $id: String!
    $name: String
    $authAmount: Float
    $hourlyRate: Float
  ) {
    updatePricingPlan(
      id: $id
      name: $name
      authAmount: $authAmount
      hourlyRate: $hourlyRate
    ) {
      ...PricingPlanFields
    }
  }
`;

export const DELETE_PRICING_PLAN = gql`
  mutation DeletePricingPlanInPortal($id: String!) {
    deletePricingPlan(id: $id) {
      id
    }
  }
`;
